import { Path } from 'react-router-dom'
import { RouteKeys, RouterPaths, routesEn, routesFi, routesSv } from './i18n/extranet-routes'

export const getRoutesForLanguage = (lang?: string) => {
  if (lang && lang === 'sv') return routesSv
  if (lang && lang === 'en') return routesEn

  return routesFi
}

export const getRoutePathForLanguage = (path: string, language?: string) => {
  const routes = getRoutesForLanguage(language)

  return routes[path as keyof typeof routes] ?? routes.root
}

const getLocalizedPaths = (language: string): RouterPaths => {
  switch (language) {
    default:
    case 'fi':
      return routesFi
    case 'sv':
      return routesSv
    case 'en':
      return routesEn
  }
}

const localizePath = (language: string, path?: RouteKeys) => {
  const prefix = language !== 'fi' ? `/${language}` : ''

  if (typeof path === 'string') {
    const paths = getLocalizedPaths(language)

    return prefix + paths[path]
  }

  return prefix
}

export const localizeLinkPath = (language: string, path?: string | Partial<Path>) => {
  const pathKeyExists = (p: unknown): p is RouteKeys => !!routesFi[p as unknown as RouteKeys]
  const validLanguage = ['fi', 'en', 'sv'].includes(language)

  if (!pathKeyExists(path) || !validLanguage) {
    return path
  }

  return localizePath(language, path)
}
